import { defineMessages } from 'react-intl';

export default defineMessages({
  separator: {
    id: 'frontbucket.respository.largeRepositoryWarning.separator',
    description:
      'The word that separates the current size of the repository and the repository size limit',
    defaultMessage: '{currentSize} of {maxSize}',
  },
  softLimitHeading: {
    id: 'frontbucket.respository.largeRepositoryWarning.softLimitHeading',
    description:
      'Heading for the warning about a repository being larger than soft limit',
    defaultMessage: 'Large repository',
  },
  softLimitDescription: {
    id: 'frontbucket.respository.largeRepositoryWarning.softLimitDescription',
    description:
      'Description for the warning about a repository being larger than soft limit',
    defaultMessage:
      'This repository is over {softLimit}. If it reaches {hardLimit}, you will not be able to push new commits. Contact your administrator to reduce the repository size. ',
  },
  softLimitDescriptionAdmin: {
    id: 'frontbucket.respository.largeRepositoryWarning.softLimitDescriptionAdmin',
    description:
      'Description for the warning about a repository being larger than soft limit',
    defaultMessage:
      'This repository is over {softLimit}. If it reaches {hardLimit}, contributors will not be able to push new commits.',
  },
  softLimitLink: {
    id: 'frontbucket.respository.largeRepositoryWarning.softLimitLink',
    description:
      'Link text for the link to documentation about reducing your repository size',
    defaultMessage: 'Learn how to reduce your repository size',
  },
  softLimitLearnMoreLink: {
    id: 'frontbucket.respository.largeRepositoryWarning.softLimitLearnMoreLink',
    description:
      'Link text for the link to documentation about reducing your repository size',
    defaultMessage: 'Learn more',
  },
  dismiss: {
    id: 'frontbucket.respository.largeRepositoryWarning.dismiss',
    description: 'Text for warning message dismiss button',
    defaultMessage: 'Dismiss',
  },
  hardLimitHeading: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitHeading',
    description:
      'Heading for the warning about a repository being larger than hard limit',
    defaultMessage: 'Repository exceeds {hardLimit} limit',
  },
  hardLimitHeadingLarge: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitHeadingLarge',
    description:
      'Heading for the warning about a repository being larger than hard limit',
    defaultMessage: 'Repository size exceeds limit',
  },
  hardLimitDescriptionLine1: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitDescriptionLine1',
    description:
      'Description for the warning about a repository being larger than hard limit',
    defaultMessage:
      'This repository is over the {hardLimit} limit and you are not able to push new commits.',
  },
  hardLimitDescriptionLine1Admin: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitDescriptionLine1Admin',
    description:
      'Description for the warning about a repository being larger than hard limit',
    defaultMessage:
      'This repository is over the {hardLimit} limit and your contributors are not able to push new commits.',
  },
  hardLimitDescriptionLine2: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitDescriptionLine2',
    description:
      'Description for the warning about a repository being larger than hard limit',
    defaultMessage:
      'To keep this from happening, {linkText} to under {hardLimit}.',
  },
  hardLimitDescriptionLine2LinkText: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitDescriptionLine2LinkText',
    description:
      'Description link text for the warning about a repository being larger than hard limit',
    defaultMessage: 'reduce the size',
  },
  hardLimitDescription: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitDescription',
    description:
      'Description for the warning about a repository being larger than hard limit',
    defaultMessage:
      'This repository is over the {hardLimit} limit and you are not able to push new commits. To resolve this, contact your repository’s admin.',
  },
  hardLimitDescriptionAdmin: {
    id: 'frontbucket.respository.largeRepositoryWarning.hardLimitDescriptionAdmin',
    description:
      'Description for the warning about a repository being larger than hard limit',
    defaultMessage:
      'This repository is over the {hardLimit} limit and your contributors are not able to push new commits. To resolve this, reduce the repository size.',
  },
  readOnlyHeading: {
    id: 'frontbucket.respository.largeRepositoryWarning.readOnlyHeading',
    description:
      'Heading for the warning about a repository being in read-only mode because it is too large',
    defaultMessage: 'Repository in read-only mode, exceeds {hardLimit} limit',
  },
  readOnlyDescriptionLine1: {
    id: 'frontbucket.respository.largeRepositoryWarning.readOnlyDescriptionLine1',
    description:
      'Description for the warning about a repository being in read-only mode because it is too large',
    defaultMessage:
      'This repository is over the {hardLimit} limit and is now in read-only mode.',
  },
  readOnlyDescriptionLine2: {
    id: 'frontbucket.respository.largeRepositoryWarning.readOnlyDescriptionLine2',
    description:
      'Description for the warning about a repository being in read-only mode because it is too large',
    defaultMessage:
      '{linkText} to under {hardLimit} to enable write access again.',
  },
  readOnlyDescriptionLine2LinkText: {
    id: 'frontbucket.respository.largeRepositoryWarning.readOnlyDescriptionLine2LinkText',
    description:
      'Description link text for the warning about a repository being in read-only mode because it is too large',
    defaultMessage: 'Reduce the repository size',
  },
});
